import { FormBase } from './formBase';
import { FormField } from './formField';
import { FormType } from './formType';

export class Form extends FormBase {
  public requestUri: string;
  public deadline: Date;
  public isTemplate: boolean = false;
  public formType: FormType;
  public hasExpired: boolean = false;
  public newMemberDefaultStatus: string;
  public workspaceLogoUrl: string;
  public workspaceHelpLink: string;
  public isAddressSharedLabel: string;
  public validateAddress: boolean;
  public includePaymentPage: boolean;
  public includePositionPage: boolean;
  public isAnonymous: boolean;
  public fields: Array<FormField> = new Array<FormField>();
  public isArchived: boolean;
  public workspaceId: string;
  public isPrivate: boolean;
  public createTeam: boolean;

  public isApplication(expired: boolean | null = false, template: boolean = false): boolean {
    return this.isOfType(FormType.Application, expired, template);
  }

  public isSurvey(expired: boolean | null = false, template: boolean = false): boolean {
    return this.isOfType(FormType.Survey, expired, template);
  }

  public get isSurveyTemplate(): boolean {
    return this.formType == FormType.Survey && this.isTemplate == true;
  }

  public get isAnonymousSurvey(): boolean {
    return this.isAnonymous && this.formType === FormType.Survey;
  }

  private isOfType(formType: FormType, expired: boolean | null = false, template: boolean = false) {
    return (
      this.formType == formType &&
      (expired === null || this.hasExpired === expired) &&
      this.isTemplate == template
    );
  }

  public static anyApplication(): Form {
    return Form.parse({
      title: FormBase.getAnyApplicationTitle(),
      id: FormBase.getAnyApplicationTitle()
    });
  }

  public isSharedFromOrg(isInOrg: boolean): boolean {
    return !isInOrg && !this.workspaceId;
  }

  public static parse(data: any): Form {
    if (!data) return null;

    let form = new Form();
    Object.assign(form, data);
    form.createTeam = data.createTeam ?? false;
    form.fields = data.fields
      ? data.fields.map(
          (f) => new FormField(f.fieldName, f.isRequired, f.isHidden, f.valueList, f.customLabel)
        )
      : ([] as FormField[]);

    return form;
  }
}
